import React from 'react';

export type VersionSelectContextType = {
  selectedVersion?: string;
};

export const VersionSelectContext =
  React.createContext<VersionSelectContextType | null>(null);

export const useVersionSelectContext = (): VersionSelectContextType => {
  const context = React.useContext(VersionSelectContext);
  if (!context) {
    throw new Error('useVersionSelect must be used within VersionSelect');
  }
  return context;
};
